import { makeStyles, type DefaultTheme } from '@mui/styles';

type MakeStylesProps = {
  colors: string[];
};

export const useStyles = makeStyles<DefaultTheme, MakeStylesProps>(
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  (theme: any) => ({
    legend: {
      margin: 'auto',
      display: 'flex',
      justifyContent: 'center',
      minHeight: '42px'
    },
    legendGroup: {
      textAnchor: 'middle'
    },
    legendText: {
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      textAnchor: 'middle'
    },
    legendDot: {
      width: '13px',
      height: '13px',
      minWidth: '13px',
      borderRadius: '50%',
      marginTop: '2px',
      marginRight: '8px',
      background: ({ colors }) => `linear-gradient(90.76deg, ${colors[0]} 0%, ${colors[1]} 100%)`
    },
    helperIconTooltipWrapper: {
      display: 'inline-table',
      verticalAlign: 'bottom'
    }
  })
);
